var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasUrl && _vm.open)?_c('div',{staticClass:"vue-google-inside-wrapper",class:{'open': _vm.open }},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.url,"allowfullscreen":"","loading":"lazy"}}),_vm._v(" "),_c('button',{staticClass:"btn-close",on:{"click":_vm.handleClose}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }